import React, {useEffect, useState} from "react";
import axios from "axios";
import {baseUrl} from "../Univ.js";
import {useParams} from "react-router-dom";
import "./IoTStyles.css";
function IoTPatientVitals() {
    const {patient_id} =
        useParams();
    const [observations, setObservations] =
        useState([]);
    const [loading, setLoading] =
        useState(false);
    const fetchVitals = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl +
                "iot-patient-vitals/" +
                patient_id +
                "/"
            );
            setObservations(
                response.data
            );
        } catch (error) {
            console.log(
                "Patient IoT Error:",
                error
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (patient_id) {
            fetchVitals();
        }
    }, [patient_id]);
    const latest =
        observations.length > 0
            ? observations[0]
            : null;
    return (
        <section className="container-fluid mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>
                        Patient IoT Vitals
                    </h3>

                    <p>
                        Patient ID: {patient_id}
                    </p>

                </div>

            </div>


            {loading && (
                <div className="text-muted">
                    Loading vitals...
                </div>
            )}


            {latest && (
                <div className="row g-3 mb-4">

                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Heart Rate
                                </small>

                                <h3>
                                    {
                                        latest.heart_rate ??
                                        "--"
                                    }

                                    <small>
                                        {" "}bpm
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    SpO2
                                </small>

                                <h3>
                                    {
                                        latest.spo2 ??
                                        "--"
                                    }

                                    <small>
                                        {" "}%
                                    </small>

                                </h3>

                            </div>

                        </div>

                    </div>


                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Blood Pressure
                                </small>

                                <h3>

                                    {
                                        latest.systolic_bp ??
                                        "--"
                                    }

                                    /

                                    {
                                        latest.diastolic_bp ??
                                        "--"
                                    }

                                </h3>

                            </div>

                        </div>

                    </div>


                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Temperature
                                </small>

                                <h3>

                                    {
                                        latest.temperature ??
                                        "--"
                                    }

                                    °C

                                </h3>

                            </div>

                        </div>

                    </div>


                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Respiration
                                </small>

                                <h3>

                                    {
                                        latest.respiratory_rate ??
                                        "--"
                                    }

                                </h3>

                            </div>

                        </div>

                    </div>


                    <div className="col-md-2">

                        <div className="card shadow-sm">

                            <div className="card-body">

                                <small>
                                    Glucose
                                </small>

                                <h3>

                                    {
                                        latest.glucose ??
                                        "--"
                                    }

                                </h3>

                            </div>

                        </div>

                    </div>

                </div>
            )}


            <div className="card shadow-sm">

                <div className="card-header">

                    <strong>
                        Vital History
                    </strong>

                </div>


                <div className="card-body">

                    <div className="table-responsive">

                        <table className="table table-hover">

                            <thead>

                            <tr>

                                <th>
                                    Time
                                </th>

                                <th>
                                    HR
                                </th>

                                <th>
                                    SpO2
                                </th>

                                <th>
                                    BP
                                </th>

                                <th>
                                    Temperature
                                </th>

                                <th>
                                    Respiration
                                </th>

                                <th>
                                    Glucose
                                </th>

                            </tr>

                            </thead>


                            <tbody>

                            {observations.map(
                                observation => (
                                    <tr
                                        key={
                                            observation.id
                                        }
                                    >

                                        <td>
                                            {
                                                observation.recorded_at
                                            }
                                        </td>

                                        <td>
                                            {
                                                observation.heart_rate ??
                                                "--"
                                            }
                                        </td>

                                        <td>
                                            {
                                                observation.spo2 ??
                                                "--"
                                            }
                                        </td>

                                        <td>

                                            {
                                                observation.systolic_bp ??
                                                "--"
                                            }

                                            /

                                            {
                                                observation.diastolic_bp ??
                                                "--"
                                            }

                                        </td>

                                        <td>
                                            {
                                                observation.temperature ??
                                                "--"
                                            }
                                        </td>

                                        <td>
                                            {
                                                observation.respiratory_rate ??
                                                "--"
                                            }
                                        </td>

                                        <td>
                                            {
                                                observation.glucose ??
                                                "--"
                                            }
                                        </td>

                                    </tr>
                                )
                            )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </section>
    );
}
export default IoTPatientVitals;
